import axios from 'axios'
// create an axios instance
const service = axios.create({
  baseURL: window.location.protocol + '//' + window.location.host + '/api', // process.env.BASE_API, // api 的 base_url
  timeout: 1200000 // request timeout
})

service.defaults.timeout = 1200000
service.interceptors.request.use(
  config => {
    if (localStorage.token) {
      config.headers['Authorization'] = localStorage.token
    }
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Credentials'] = 'true'
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error)
  }
)

export default service